import { MelcoCoreModelsUserBlank } from "melco-shared-logic";

type DisplayBlankDrawerSelectValueProps = {
  blank: MelcoCoreModelsUserBlank;
};

export const DisplayBlankDrawerSelectValue: React.FC<
  DisplayBlankDrawerSelectValueProps
> = ({ blank }) => <>{blank.name}</>;
